<template>
    <div class="hongwai-monitor-wrap">
        <div style="padding: 0 20px">
            <div class="title-wrap-energy">
                <span class="split-line-energy"></span>
                采集点选择
            </div>
            <me-tree
                ref="myTree"
                :treeData="treeData"
                :treeLoading="treeLoading"
                :treeToolBar="false"
                :defaultProps="defaultProps"
                :nodeKey="'point_id'"
                :showCheckbox="false"
                :cascadingVar="false"
                :checkStrictly="true"
                :isCheckClick="true"
                :defaultCheckKeys="defaultCheckKeys"
                :defaultExpandedKeys="defaultCheckKeys"
                @handleTreeNodeClick="handleTreeNodeClick"
                :showStretch="true"
            ></me-tree>
        </div>
        <div class="data-wrap">
            <div class="search-wrap">
                <el-form
                    :inline="true"
                    :model="searchForm"
                    class="leader-style-form leader-form-inner-tab-inline"
                >
                    <el-row :gutter="10">
                        <el-col :md="10" :xl="8">
                            <el-form-item label="开始时间" style="float: left">
                                <img
                                    @click="lastDayFrom"
                                    style="width: 25px;height: 25px;margin-right: 5px;cursor:pointer;"
                                    src="../../../../assets/image/custom/date_left.png"
                                    alt
                                />
                                <el-date-picker
                                    v-model="searchForm.startTime"
                                    type="date"
                                    placeholder="选择日期"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    :clearable="false"
                                    :editable="false"
                                ></el-date-picker>
                                <img
                                    @click="nextDayFrom"
                                    style="width: 25px;height: 25px;margin-left: 5px;cursor:pointer;"
                                    src="../../../../assets/image/custom/date_right.png"
                                    alt
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :md="10" :xl="8">
                            <el-form-item label="结束时间">
                                <img
                                    @click="lastDayTo"
                                    style="width: 25px;height: 25px;margin-right: 5px;cursor:pointer;"
                                    src="../../../../assets/image/custom/date_left.png"
                                    alt
                                />
                                <el-date-picker
                                    v-model="searchForm.endTime"
                                    type="date"
                                    placeholder="选择日期"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    :clearable="false"
                                    :editable="false"
                                ></el-date-picker>
                                <img
                                    @click="nextDayTo"
                                    style="width: 25px;height: 25px;margin-left: 5px;cursor:pointer;"
                                    src="../../../../assets/image/custom/date_right.png"
                                    alt
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :md="4" :xl="8" style="text-align: right;">
                            <el-button type="primary" @click="search" size="small">查询</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="chart-data-wrap">
                <template v-if="this.state == 1">
                    <div style="text-align: center;line-height: 100%;height: 100%">
                        <img
                            style="margin-top: 10rem;"
                            src="../../../../assets/image/custom/no-collector.jpg"
                        />
                    </div>
                </template>
                <template v-else>
                    <div class="chart-wrap">
                        <el-scrollbar style="height: 100%">
                            <el-table
                                class="leader-style-table"
                                :data="tableData"
                                style="width: 100%;height: 100%"
                            >
                                <el-table-column label="时间" property="upload_time" align="center"></el-table-column>
                                <el-table-column
                                    label="开关状态"
                                    property="current_value"
                                    align="center"
                                ></el-table-column>
                                <el-table-column
                                    label="开关状态名称"
                                    property="current_name"
                                    align="center"
                                ></el-table-column>
                            </el-table>
                        </el-scrollbar>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import * as api from "@/http/api.js";
import dayjs from "dayjs";
export default {
    components: {
        "me-tree": Tree
    },
    data() {
        return {
            state: 1,
            treeData: [],
            treeLoading: false,
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            defaultCheckKeys: [],
            nextTimeDisabled: false,
            searchForm: {
                startTime: "",
                endTime: "",
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            sysDate: "",
            tableSwitch: true,
            tableData: [],
            current_point: null,
            loading: false,
        };
    },
    created() {
        this.getSysDate();
        this.todayY = this.getTimeValue("year");
        this.nextTimeDisabled = true;
    },
    methods: {
        //获取系统时间
        getSysDate() {
            api.getSysDate1({}).then(res => {
                if (res) {
                    this.searchForm.startTime = res.bus_json.sysdate;
                    this.searchForm.endTime = res.bus_json.sysdate;
                    this.sysDate = res.bus_json.sysdate;
                    this.getPointList();
                }
            });
        },
        //获取采集点
        getPointList() {
            this.treeLoading = true;
            api.getUnitPointList({ point_class_id: '095' }).then(res => {
                if (res) {
                    this.treeLoading = false;
                    this.treeData = res.bus_json;
                    this.$refs.myTree.handleNodeClick(res.bus_json[0]);
                    this.defaultExpandedKeys = [res.bus_json[0].point_id];
                    // this.defaultCheckKeys = [res.bus_json[0].point_id];
                    this.current_point = res.bus_json[0];
                    this.state = res.bus_json[0].state;
                    this.search();
                }
            });
        },
        handleTreeNodeClick(node) {
            // this.defaultCheckKeys = this.$refs.myTree.$refs.tree.getCheckedKeys();
            this.current_point = node;
            this.state = node.state;
            this.search();
        },
        /**
         * 获取时间值
         * params{type<string>} type = day(日) type = month(月) type = year(年)
         */
        getTimeValue(type) {
            let date = new Date();
            if (type === "year") {
                return date.getFullYear() + "";
            } else if (type === "month") {
                return date.getFullYear() + "-" + (date.getMonth() + 1);
            } else {
                return (
                    date.getFullYear() +
                    "-" +
                    (date.getMonth() + 1) +
                    "-" +
                    date.getDate()
                );
            }
        },
        /**
         * 日期改变回调函数
         */
        handleTimeChange(val) {
            let toDay = new Date(this.todayY).getTime();
            let selectTime = new Date(val).getTime();
            if (selectTime >= toDay) {
                this.nextTimeDisabled = true;
            } else {
                this.nextTimeDisabled = false;
            }
            this.search();
        },
        //上一日
        lastDayFrom() {
            const now = dayjs(this.searchForm.startTime);
            this.searchForm.startTime = now.subtract(1, "days").format("YYYY-MM-DD");
            //this.search();
        },
        // 下一日
        nextDayFrom() {
            const now = dayjs(this.searchForm.startTime);
            this.searchForm.startTime = now.add(1, "days").format("YYYY-MM-DD");
            //this.search();
        },
        //上一日
        lastDayTo() {
            const now = dayjs(this.searchForm.endTime);
            this.searchForm.endTime = now.subtract(1, "days").format("YYYY-MM-DD");
            // this.search();
        },
        // 下一日
        nextDayTo() {
            const now = dayjs(this.searchForm.endTime);
            this.searchForm.endTime = now.add(1, "days").format("YYYY-MM-DD");
            // this.search();
        },
        search() {
            this.getDataMonitor();
        },
        getDataMonitor() {
            const diff = dayjs(this.searchForm.endTime).diff(dayjs(this.searchForm.startTime), 'day');
            if (diff > 2) {
                this.$message({
                    message: '时间查询范围不可大于3天',
                    type: "warning"
                });
                return;
            }
            this.loading = true;
            api.getDataMonitor({
                ...this.searchForm,
                type: '红外',
                point_id: this.current_point.point_id
            }).then(res => {
                if (res) {
                    this.tableData = res.bus_json;
                }
                this.loading = false;
            });
        }
    },
    computed: {
    }
};
</script>
<style lang="scss">
.hongwai-monitor-wrap {
    width: 100%;
    height: 93%;
    display: flex;
    flex-direction: row;
    .title-wrap-energy {
        text-align: left;
        font-size: 16px;
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding-left: 10px;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #fff;
        justify-content: left;
        border-bottom: 1px solid #dedede;
        margin-bottom: 10px;
        .title-energy {
            padding-right: 10px;
        }
        .split-line-energy {
            display: inline-block;
            background: #56fcff;
            width: 4px;
            height: 14px;
            border-radius: 2px;
            margin-right: 10px;
        }
    }
    .data-wrap {
        width: calc(100% - 300px);
        height: 100%;
        box-sizing: border-box;
        padding: 20px;
        .search-wrap {
            margin-top: 10px;
            margin-bottom: 15px;
            width: 100%;
            .time_btn {
                background: #29b85e;
                color: #fff;
            }
            .el-radio {
                margin-left: 20px;
                margin-right: 10px;
                color: #fff;
            }
            .el-radio__input.is-checked + .el-radio__label {
                color: #fff;
            }
            .el-radio__input.is-checked .el-radio__inner {
                border-color: #56fcff;
                background: #56fcff;
            }
        }
        .chart-data-wrap {
            width: 100%;
            background: url("../../../../assets/image/custom/table-bg.png")
                no-repeat;
            background-size: 100% 100%;
            padding: 30px;
            box-sizing: border-box;
            height: 97%;
            .btn_cont {
                text-align: right;
                .btn_1 {
                    color: #56fbff;
                    text-align: center;
                    border-width: 1px;
                    border-color: #56fbff;
                    border-style: solid;
                    border-radius: 8px;
                    background-color: rgba(86, 251, 255, 0);
                    cursor: pointer;
                }
                .btn_3 {
                    color: #fff;
                }
            }
        }
        .chart-wrap {
            width: 100%;
            height: 97%;
            margin-top: 30px;
            .echart-container {
                width: 100%;
                height: 100%;
                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
}
</style>
